var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main"},[_c('div',{staticClass:"up"},[_vm._v(_vm._s(_vm.comp.introEn))]),_c('div',{staticClass:"down"},[_vm._v(_vm._s(_vm.comp.contactEn))])])
}
var staticRenderFns = []

export { render, staticRenderFns }